import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ProductAdminResponse } from './types';

export async function getProductAdmin(productId: string) {
  const url = `/web/studio/products/${productId}`;

  const response = await api.executeGetRequest<ObjectResponse<ProductAdminResponse>>(url);

  return response.data;
}
